import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  continue: {
    description: 'search result list continue button',
    defaultMessage: 'Continue',
    id: 'GEMEA+',
  },
  cancel: {
    description: 'search result list cancel button',
    defaultMessage: 'Cancel',
    id: 'VoM37g',
  },
  itemCountOrders: {
    description: 'scanToPrint.orderSearchResult.itemCountOrders',
    defaultMessage: '{itemCount, plural,=0 {# items} one {# item} other {# items}}',
    id: '4cBS15',
  },
  shipmentListTitle: {
    defaultMessage: 'Shipment {displayIndex}',
    description: 'shipment list shipment number',
    id: 'G0smBI',
  },
  shipmentListItems: {
    defaultMessage: 'Shipment Items',
    description: 'shipment list shipment items label',
    id: 'qM2Chr',
  },
  quantityTitle: {
    defaultMessage: 'Qty',
    description: 'shipment list items quantity label',
    id: 'OVAl3G',
  },
});
